/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Contact_TitleInputs */

const en_faq_contact_title = /** @type {(inputs: Faq_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your question isn’t here?`)
};

const lv_faq_contact_title = /** @type {(inputs: Faq_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu jautājuma šeit nav?`)
};

/**
* | output |
* | --- |
* | "Your question isn’t here?" |
*
* @param {Faq_Contact_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_contact_title = /** @type {((inputs?: Faq_Contact_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Contact_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_contact_title(inputs)
	return en_faq_contact_title(inputs)
});